import { collection, getDocs, doc, getDoc, query, where, serverTimestamp, orderBy, addDoc } from "firebase/firestore";
import { db } from "../../firbase"; // Update the path to your Firebase config file

export const fetchChatrooms = async (userUid) => {
    try {
        const chatroomQuery = query(
            collection(db, "chatrooms"),
            where(`participants.${userUid}`, "==", true)
        );

        const chatroomSnapshot = await getDocs(chatroomQuery);
        let chatrooms = chatroomSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        console.log('chat', chatrooms)

        // For each chatroom, fetch the other participant's name
        const chatroomsWithParticipantNames = await Promise.all(
            chatrooms.map(async (chatroom) => {
                // Get the other participant's UID
                const participantUids = Object.keys(chatroom.participants);
                const otherUid = participantUids.find(uid => uid !== userUid); // Find the other participant's UID

                // Fetch the name of the other participant from the users collection
                const userDocRef = doc(db, "users", otherUid); // Replace 'users' with your Firestore collection name
                const userDoc = await getDoc(userDocRef);

                let otherName = "Unknown Participant";
                if (userDoc.exists()) {
                    otherName = userDoc.data().name; // Assuming you have a 'name' field in your users collection
                }

                return {
                    ...chatroom,
                    otherParticipantName: otherName, // Add the name to the chatroom object
                };
            })
        );

        // Sort chatrooms by last message in descending order
        chatroomsWithParticipantNames.sort((a, b) => b.lastmessage.localeCompare(a.lastmessage));

        console.log('chat', chatroomsWithParticipantNames)

        return chatroomsWithParticipantNames;
    } catch (error) {
        console.error("Error fetching chatrooms:", error);
        throw error;
    }
};

